import { AutocompleteInput, ReferenceField, ReferenceInput, SelectField, SelectInput } from "react-admin";
import { getProfessorRecordText } from "./_fieldsHelper";
import { employeeRequests } from "api/employeeApi";

const ProfessorInput = ({
  source,
  label = "Преподавател",
  filters = {},
  fullWidth = false,
  autocomplete = true,
  validate = null,
  readonly = false,
  disabled = false,
  type = "input",
  alwaysOn = false,
  style,
  onChange,
}) => {
  if (type === "field") {
    return (
      <ReferenceField
        source={source}
        reference={employeeRequests.getProfessorsSelect()}
        filter={filters}
      >
        <SelectField
          label={label}
          optionText={getProfessorRecordText}
        />
      </ReferenceField>
    );
  }

  return (
    <ReferenceInput
      source={source}
      reference={employeeRequests.getProfessorsSelect()}
      fullWidth={fullWidth}
      filter={filters}
      alwaysOn={alwaysOn}
      readOnly={readonly}
    >
      {autocomplete ? (
        <AutocompleteInput
          label={label}
          optionValue="id"
          optionText={getProfessorRecordText}
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          fullWidth={fullWidth}
          validate={validate}
          style={style}
          onChange={onChange}
          disabled={disabled}
        />
      ) : (
        <SelectInput
          label={label}
          optionText={getProfessorRecordText}
          onChange={onChange}
        />
      )}
    </ReferenceInput>
  );
};

export default ProfessorInput;
